import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Tooltip from '@material-ui/core/Tooltip';

import AddBucketAssetDialog from './AddBucketAssetDialog';

import * as assetSelectors from '../../selectors/assetSelectors';
import toggleDialog from '../../hoc/ToggleDialog';
import injectSheet from 'react-jss';
import Avatar from '../../components/Avatar';

export function AddBucketAsset({ classes, asset, toggleDialog, isDialogOpen }) {
    return (
        <React.Fragment>
            <Tooltip title={`Create ${asset.toLowerCase()}`}>
                <Avatar
                    onClick={toggleDialog}
                    className={classes.createButton}
                    data-testid="create-project-button"
                >
                    <i className="material-icons">add</i>
                </Avatar>
            </Tooltip>

            <AddBucketAssetDialog
                isDialogOpen={isDialogOpen}
                toggleDialog={toggleDialog}
            />
        </React.Fragment>
    );
}

const mapStateToProps = state => ({
    asset: assetSelectors.getApplicationAsset(state),
});

const style = ({ palette, spacing }) => ({
    createButton: {
        cursor: 'pointer',
        height: '38px',
        width: '38px',
        background: palette.primary.main,
        color: palette.common.white,
        boxShadow: '0 0 6px 0 rgba(0,0,0,0.12), 0 6px 6px 0 rgba(0,0,0,0.24)',
        '&:hover': {
            backgroundColor: palette.info.secondary,
        },
    },
});

AddBucketAsset.propTypes = {
    asset: PropTypes.string,
    toggleDialog: PropTypes.func.isRequired,
    isDialogOpen: PropTypes.bool.isRequired,
};

AddBucketAsset.defaultProps = {
    asset: '',
};

export default connect(mapStateToProps)(
    injectSheet(style)(toggleDialog(AddBucketAsset)),
);



// WEBPACK FOOTER //
// ./src/containers/bucketAssets/AddBucketAsset.js